import { render, staticRenderFns } from "./AwardBuyModalWalletRangeContent.vue?vue&type=template&id=e328780e&scoped=true"
import script from "./AwardBuyModalWalletRangeContent.vue?vue&type=script&lang=js"
export * from "./AwardBuyModalWalletRangeContent.vue?vue&type=script&lang=js"
import style0 from "./AwardBuyModalWalletRangeContent.vue?vue&type=style&index=0&id=e328780e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e328780e",
  null
  
)

export default component.exports